<template>
  <div class='container'>
    <div class='complete'>
      <div class='c_title'><i class="iconfont icon-icon-test"></i>{{isInvitation ? '评价提交成功' : '订单提交成功'}}</div>
      <div class='t_999 c_content'>
      <template v-if="!ismanual">
        <div v-if="isInvitation" class='invitation-text'>管理员将在
          <span class='t_FF9900'> {{invitationTime || '次日16：00'}} </span> 前完成审核。审核通过后奖励的免单卡将直接发放到你的账户中
        </div>
        <div class='pad_left_10' v-else>收到商品后，记得回来领取返利哦！</div>
      </template>
      <template v-else>
        <div class='pad_left_10'> 请等待管理员审核，</div>
        <div>审核通过后该订单即可正常返利</div>
      </template>
      </div>
      <div class='c_button flex'>
      <div class='border_btn c_btn'>返回首页
        <button @click="backHome"></button>
      </div>
      <div class='black_btn c_btn' v-if="isInvitation">查看评价
        <button @click="checkInvitation"></button>
      </div>
      <div class='black_btn c_btn' v-else>查看订单
        <button @click="checkOrder"></button>
      </div>
      </div>
    </div>
    <div class='coupons'>
      <div class='coupons_bg'>
        <img :src='youpPath + shareBg' alt=""/>
      </div>
      <div class='abs_coupons'>
        <div class='t_999'>好友注册各得一张免单卡</div>
        <div class='coupons_img'>
        <img :src='youpPath + shareCoupons' alt=""/>
          <div class='abs_coupons_txt flex'>
            <div class='coupons_fl'>
              <div class='coupons_text'>免单卡</div>
              <div class="freecard-text coupons_text">分享获得一次购物免单机会</div>
            </div>
            <div class='coupons_fr'>
              <div class='share_btn' @click="shareClick">立即分享</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <lucky-package-dialog
      v-if="dialogShow"
      :show-open-btn="showOpenBtn"
      :mask-show="maskShow"
      :money-box-show="moneyBoxShow"
      :is-start-anim="isStartAnim"
      :data-info="dataInfo"
      @openLuckyPacket="openLuckyPacket"
      >
    </lucky-package-dialog>
  </div>
</template>

<script>
import { IMG_BASE_URL } from '@/config'
import LuckyPackageDialog from '@/components/smartComponent/luckyPackage/LuckyPackageDialog'
import { RedPacketInfo } from '@/api/order'
import { Indicator } from 'mint-ui'
import { setStore } from '@/utils/session'

export default {
  data () {
    return {
      ismanual: false,
      // 是否评价提交进入此页面
      isInvitation: false,
      invitationTime: null,
      productID: null,
      titleShort: null,
      youpPath: IMG_BASE_URL,
      sharePic: '/upaiyun/Sys/20180718/5694911098040020986.png',
      shareBg: '/upaiyun/Sys/20180803/4982315802108632151.png',
      shareCoupons: '/upaiyun/Sys/20180803/4802325502993501279.png',
      // 是否授权
      loginState: false,
      taskID: null,
      dataInfo: {},
      dialogShow: false,
      showOpenBtn: true,
      maskShow: true,
      moneyBoxShow: true,
      isStartAnim: false,
      timeOut: null
      // isAllowUserInfo: false
    }
  },
  components: {
    LuckyPackageDialog
  },
  mounted () {
    let routeQuery = this.$route.query
    if (!routeQuery.ismanual || routeQuery.ismanual === 'false') {
      this.ismanual = false
    } else {
      this.ismanual = true
    }
    if (!routeQuery.isInvitation || routeQuery.isInvitation === 'false') {
      this.isInvitation = false
    } else {
      this.isInvitation = true
    }
    if (routeQuery.time) {
      this.invitationTime = decodeURIComponent(routeQuery.time)
    }
    this.productID = routeQuery.productID ? routeQuery.productID : null
    this.titleShort = routeQuery.titleShort ? routeQuery.titleShort : null
    this.taskID = routeQuery.taskID ? routeQuery.taskID : null
  },
  beforeDestroy () {
    this.resetDialog()
  },
  methods: {
    fetchData () {
      Indicator.open({
        text: '加载中',
        spinnerType: 'triple-bounce'
      })
      RedPacketInfo({ taskId: this.taskID }).then(res => {
        Indicator.close()
        this.dataInfo = res.Data
        this.dialogShow = true
        setStore('WXUserImg', res.Data.HeadPortraitUrl)
      }).catch(() => {
        Indicator.close()
      })
    },
    // 打开红包
    openLuckyPacket () {
      this.showOpenBtn = false
      this.timeOut = setTimeout(() => {
        // 1000ms为钱币动画时间
        this.maskShow = false
        this.moneyBoxShow = false
        this.isStartAnim = true
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(() => {
          this.$router.push({
            name: 'luckyPackage',
            query: {
              price: this.dataInfo.BuyRebatePrice,
              taskID: this.taskID
            }
          })
        }, 300)
      }, 1000)
    },
    resetDialog () {
      this.dialogShow = false
      this.showOpenBtn = true
      this.maskShow = true
      this.moneyBoxShow = true
      this.isStartAnim = false
      clearTimeout(this.timeOut)
    },
    backHome () {
      this.$router.replace('souhuo')
    },
    // 查看评价
    checkInvitation () {
      this.$router.push({
        name: 'invitationEvaluation',
        query: {
          tabIndex: 1
        }
      })
    },
    checkOrder () {
      let tabIndex = 2
      if (this.ismanual) {
        tabIndex = 1
      }
      this.$router.push({
        name: 'order',
        query: {
          tabIndex: tabIndex
        }
      })
    },
    shareClick () {
      this.$router.push({
        name: 'ShareByImg',
        query: {
          pageType: 12
        }
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.resetDialog()
    next()
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.resetDialog()
      vm.$nextTick(() => {
        if (!vm.ismanual) {
          if (vm.taskID) {
            if (from.name === 'orderSubmit') vm.fetchData()
          } else {
            // Toast('无任务ID')
          }
        }
      })
    })
  }
}
</script>

<style scoped>
  .flex{
    display: flex;
  }
  .align-items{
    align-items: center;
  }
  .space-between{
    justify-content:space-between;
  }
  .flex-sh{
    flex-shrink: 0;
  }
  /* 完成订单，引导用户分享 */
  .complete{
    background: #fff;
    text-align: center;
    border-top: 1px solid #eee;
    padding: 25px 0;
  }
  .c_title{
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .c_title i{
    margin-right: 5px;
    color: #09BB07;
    font-size: inherit;
  }
  .pad_left_10{
    text-indent: 10px;
  }
  .invitation-text{
    padding: 0 80px;
    margin: 0 auto;
    text-align: center;
  }
  .invitation-text > span{
    font-weight: 600;
    color: #FF9900;
  }
  .c_content{
    margin-top: 4%;
    font-size: 14px;
  }
  .c_button{
    justify-content: center;
    margin: 30px 15px 0 15px;
  }
  .c_btn{
    width: 7em;
    height: 2.3em;
    line-height: 2.3em;
    text-align: center;
    border-radius:5px;
    font-size: 14px;
    margin: 0 4%;
    position: relative;
    border: 1px solid #2c2c2c;
  }
  .black_btn{
    background: #2c2c2c;
    color: #fff;
  }
  .c_btn button{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
  }
  .coupons{
    margin-top: 3%;
    background: #fff;
  }
  .coupons{
    width: 100%;
    height: 15.4em;
    position: relative;
  }
  .coupons_bg img{
    width: 100%;
    height: 100%;
  }
  .abs_coupons{
    position: absolute;
    width: 100%;
    top:4.8em;
    left: 0;
    text-align: center;
  }

  .coupons_img{
    width: 80%;
    height: 80px;
    margin: 4% auto 0;
    position: relative;
    box-sizing: border-box;
  }
  .coupons_img img{
    width: 100%;
    height: 100%;
  }
  .abs_coupons_txt{
    position: absolute;
    align-items: center;
    justify-content: space-between;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    padding: 0 2% 0 6%;
    box-sizing: border-box;
  }
  .coupons_fl{
    color: #fff;
    flex-grow: 1;
    box-sizing: border-box;
    flex-grow: 7;
  }
  .fs_80{
    font-size: 40px;
    line-height: 40px;
  }
  .coupons_text{
    text-align: left;
  }
  .coupons_fr{
    flex-grow: 4;
  }
  .share_btn{
    width: 75%;
    height: 30px;
    min-width: 65px;
    line-height: 30px;
    background: #fff;
    color: #f98197;
    margin:0 auto;
    border-radius: 5px;
    text-align: center;
    font-size: 14px;
    position: relative;
  }
  .freecard-text{
    font-size: 12px;
  }
  @media screen and (max-width: 320px){
    .coupons_img{
      width: 90%;
    }
  }
</style>
